module.exports = __webpack_public_path__ + "fonts/庞门正道粗书体.e453aa97.ttf";